import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { getLanguage } from '../../state/theme/theme.selector';
import { StyledWrapper } from './Footer.styled';

const Footer = (props) => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const language = useSelector(getLanguage);

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [dispatch, i18n, language]);

  return (
    <StyledWrapper>
      <h3>Visitor counter</h3>
      <img
        src='https://counter1.stat.ovh/private/freecounterstat.php?c=3qz85cftlq5g2nud4s1akh62c41a7ghc'
        border='0'
        title='visitor counter script'
        alt='visitor counter script'
      />
      <p>Copyright © 2021 BK Traffic, Inc.</p>
    </StyledWrapper>
  );
};

export default Footer;
